import { Routes, Route, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Foot from './components/Foot'
import Marksheet from './components/MarkSheet'

import './css/stylesheet.css';
import './css/default.css';
import './css/bootstrap.css';
import './css/font-awesome.min.css';
import './css/GridviewScroll.css';
import './css/Marksheet.css';

const App = () => {
  return (
    <div className='app'>
      <div className="container container-border">
        <Navbar />
        <Routes>
          <Route path="/" element={<Foot />} />
          <Route path="/mark-Sheet" element={<Marksheet />} />
        </Routes>
        <Footer />
      </div>
    </div>
  )
}

export default App
